module.exports = __webpack_public_path__ + "img/grid-2.dce21823.svg";